import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "bg-inprogressShade min-w-block rounded-sm mr-2" }, null, -1)
const _hoisted_2 = { class: "bg-lightRed p-2 w-64 flex justify-between rounded-sm" }
const _hoisted_3 = { class: "overflow-hidden" }
const _hoisted_4 = { class: "block text-lg leading-tight truncate" }
const _hoisted_5 = { class: "font-semibold leading-tight" }
const _hoisted_6 = { class: "lowercase" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, " - ", -1)
const _hoisted_8 = { class: "lowercase" }
const _hoisted_9 = { class: "lowercase" }
const _hoisted_10 = {
  key: 0,
  class: "p-2"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "bg-availableShade min-w-block rounded-sm mr-2" }, null, -1)
const _hoisted_12 = { class: "bg-lightGreen p-2 flex-grow rounded-sm" }
const _hoisted_13 = { class: "text-lg leading-tight truncate" }
const _hoisted_14 = {
  key: 0,
  class: "font-semibold leading-tight text-available"
}
const _hoisted_15 = { class: "lowercase" }
const _hoisted_16 = { class: "lowercase" }
const _hoisted_17 = {
  key: 1,
  class: "font-semibold leading-tight text-available"
}
const _hoisted_18 = { class: "lowercase" }

import { computed } from "vue";
import { getDayDifference, getTimeDiff, formatTime, MINUTE } from "@/helpers/Time";
import { UpcomingItem } from "./upcoming";
import { getReservationSize } from "@/helpers/Reservations";
import { useI18n } from "vue-i18n";
import { useProfileStore } from "@/store/Profile";

interface Props {
  item: UpcomingItem;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: UpcomingItem;
}



const { t } = useI18n();
const profileStore = useProfileStore();

const startTime = computed(() => {
  return formatTime(props.item.startTime, profileStore.tabletTimeFormat);
});

const endTime = computed(() => {
  return formatTime(props.item.endTime, profileStore.tabletTimeFormat);
});

const pastDays = computed(() => {
  const startDelta = getDayDifference(new Date(), props.item.startTime);
  return startDelta !== 0 ? `${startDelta}d` : "";
});

const futureDays = computed(() => {
  const endDelta = getDayDifference(new Date(), props.item.endTime);
  return endDelta !== 0 ? `+${endDelta}d` : "";
});

const isPending = computed(() => {
  return props.item.pending === true;
});

const pendingIcon = computed(() => {
  return props.item.pending ? ["fal", "hourglass-start"] : ["fal", "check"];
});

const style = computed(() => {
  const reservationLength = getTimeDiff(props.item.endTime, props.item.startTime) / MINUTE;
  let size = getReservationSize(reservationLength);
  return `my-1 flex overflow-hidden flex-grow h-${size}`;
});

const reservationTitle = computed(() => {
  return props.item.title ? props.item.title : t("noTitleFallback");
});

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (!props.item.emptySlot)
    ? (_openBlock(), _createElementBlock("li", {
        key: 0,
        class: _normalizeClass(_unref(style))
      }, [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(reservationTitle)), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(startTime)), 1),
              _createElementVNode("sup", null, _toDisplayString(_unref(pastDays)), 1),
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(endTime)), 1),
              _createElementVNode("sup", _hoisted_9, _toDisplayString(_unref(futureDays)), 1)
            ])
          ]),
          (_unref(isPending))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_FontAwesomeIcon, {
                  icon: _unref(pendingIcon),
                  size: "2x"
                }, null, 8, ["icon"])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2))
    : (_openBlock(), _createElementBlock("li", {
        key: 1,
        class: _normalizeClass(_unref(style))
      }, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(reservationTitle)), 1),
          (!props.item.isLast)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(startTime)) + " - ", 1),
                _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(endTime)), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("fromTime", { startTime: _unref(startTime) })), 1)
              ]))
        ])
      ], 2))
}
}

})